module.exports = __webpack_public_path__ + "img/riesgos.9ab519eb.svg";